import { v4 as uuid } from 'uuid'

import { serviceDependencies } from 'src/services'

import { actions } from './slice'

export const { saveBingoProducts, saveBingoRooms, saveBingoRoomsJackpots } = actions

// TODO rewrite on openapi request when backend will do it
export const getBingoRoomsRequest = (cookies?: string, headers?: Record<string, string>) => {
  const path = typeof window === 'undefined' ? process.env.SERVER_FETCH_URL : process.env.GATEWAY
  const url = `${path}/v1/dispatch/GetBingoRoomsRequest?brandName=${process.env.BRAND_NAME}&platform=web`
  const GCBody = {
    headers: { messageId: uuid(), timestamp: Date.now() },
    body: {
      type: 'GetBingoRoomsRequest',
      currency: 'GOLD',
    },
  }
  const SCBody = {
    headers: { messageId: uuid(), timestamp: Date.now() },
    body: {
      type: 'GetBingoRoomsRequest',
      currency: 'SC',
    },
  }

  return Promise.all([
    serviceDependencies
      .fetch(url, GCBody, { method: 'post', cookies }, headers)
      .then((response) => response.json())
      .then((response) => response?.body?.activeRooms)
      .catch((err) => {
        console.log('Error getBingoRoomsRequest GOLD', err)
      }),
    serviceDependencies
      .fetch(url, SCBody, { method: 'post', cookies }, headers)
      .then((response) => response.json())
      .then((response) => response?.body?.activeRooms)
      .catch((err) => {
        console.log('Error getBingoRoomsRequest SC', err)
      }),
  ])
}
